import { ReactComponent as Icon } from './dateIcon.svg'
import { theme } from '@ss/meta-core-components'
import React from 'react'
import { config } from '../../../config'

interface Props {
  ariaLabel?: string
  role?: string
}

export const DateIcon: React.FC<Props> = ({
  ariaLabel = 'date',
  role = 'icon',
}) => {
  return (
    <Icon
      aria-label={ariaLabel}
      role={role}
      data-cy={'date-icon'}
      fill={
        theme.type === 'dark' ? config.iconColorDark : config.iconColorLight
      }
    />
  )
}
